// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InterestCategory } from './interest-category';
import { InterestSurveyInterest } from './interest-survey-interest';
import { PersonInterest } from './person-interest';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Interest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  interestCategoryId?: number;
  name!: string;
  interestCategory!: InterestCategory;
  interestSurveyInterest!: InterestSurveyInterest[];
  personInterests!: PersonInterest[];
}

